import * as yup from 'yup';

const optional = yup.object().shape({
  title: yup.string(),
  description: yup.string(),
});

const required = yup.object().shape({
  title: yup.string().required('common.required'),
  description: yup.string()
    .test('empty-tag', 'common.required', (value) => value !== '<p></p>')
    .required('common.required'),
});

const translationSchema = {
  optional,
  required,
};

export default translationSchema;
